import * as Gamee from "./GameeWrapper";



export const enum eMissionType {
    /**
     * Zasahni 5 krat cil
     */
    hitTarget5,
    /**
     * Zasahni X krat stred terce
     */
    hitTargetCenter,
    /**
     * Ziskej fireball
     */
    getFireBall,
}



export interface Mission {
    /**
     * Typ mise
     */
    type: eMissionType,
    /**
     * Jmeno mise
     */
    name: string,
    /**
     * Vychozi cilova hodnota mise
     */
    targetValue: number
}



export class MissionManager {
    /**
     * Seznam vsech misi
     */
    private static readonly _MISSIONS: Mission[] = [
        {
            type: eMissionType.hitTarget5,
            name: "hitTarget5",
            targetValue: 5
        },
        {
            type: eMissionType.hitTargetCenter,
            name: "hitTargetCenter",
            targetValue: 1
        },
        {
            type: eMissionType.getFireBall,
            name: "getFireBall",
            targetValue: 1
        }
    ];

    /**
     * (RO) Aktualni mise
     */
    get mission(): Mission { return this._mission; }
    private _mission: Mission;

    /**
     * Aktualni hodnota mise
     */
    private _missionValue: number;

    /**
     * Cilova hodnota mise
     */
    private _missionTargetValue: number;

    //-------------------------------------------------------------------------
    /**
     * Nastaveni aktivni mise podle jmena mise
     * @param name
     * @param targetVal Cilova hodnota mise. Pokud <= 0, tak se pouzije vychozi cilova hodnota
     */
    //-------------------------------------------------------------------------
    setActiveMission(name: string, targetVal: number): void {
        this._mission = undefined;
        this._missionValue = 0;

        let i = MissionManager._MISSIONS.length;

        while (i-- != 0) {
            if (MissionManager._MISSIONS[i].name == name) {
                this._mission = MissionManager._MISSIONS[i];
                this._missionTargetValue = (targetVal > 0 ? targetVal : this._mission.targetValue);
                break;
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    resetMissionProgress(): void {
        this._missionValue = 0;
    }

    //-------------------------------------------------------------------------
    /**
     * Navyseni hodnoty mise o 1
     * @param missionType Typ mise
     * @param value O kolik se ma hodnota mise navysit. Default = 1
     */
    //-------------------------------------------------------------------------
    incMissionProgress(missionType: eMissionType, value: number = 1): void {
        if (this._mission && this._mission.type == missionType)
            Gamee.Wrapper.updateMissionProgress(Math.floor(((this._missionValue += value) / this._missionTargetValue) * 100))
    }

    //-------------------------------------------------------------------------
    /**
     * Nastaveni hodnoty mise. Hodnota mise se zmeni pouze pokud nova hodnota je vyssi nez stavajici.
     * @param missionType 
     * @param value 
     */
    //-------------------------------------------------------------------------
    setMissionValue(missionType: eMissionType, value: number): void {
        if (this._mission && this._mission.type == missionType) {
            if (value > this._missionValue) {
                this._missionValue = value;
                Gamee.Wrapper.updateMissionProgress(Math.floor((this._missionValue / this._missionTargetValue) * 100));
            }
        }
    }
}